import { Reference } from '@sanity/types';
import imageUrlBuilder from '@sanity/image-url';

import { ParentCategory } from 'lib/sanity/types';
import { config } from 'lib/sanity/config';

export const emptyChildCategoriesFilter = ({ childCategories }: ParentCategory): boolean => childCategories.length > 0;

export const urlForImage = (source: Reference, maxWidth: number): string => {
  return imageUrlBuilder(config).image(source).auto('format').width(maxWidth).fit('max').url();
};
